import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStore } from '../auth/auth-store';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  // An explicit token wins: the offline sync replays with the token of the loan it belongs to.
  if (req.headers.has('token')) return next(req);
  const authStore = inject(AuthStore);
  const modifiedRequest = req.clone({
    headers: req.headers.set('token', authStore.token()),
  });

  return next(modifiedRequest);
};
